import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/new-subscription')({
  component: () => <Navigate replace search to="/bo/subscriptions/new" />,
})
